:host {
  .mail-success {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &-image {
      margin-bottom: 30px;
    }

    &-title {
      color: #333333;
      color: var(--font-primary);
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 16px;
    }

    &-ticket {
      display: flex;
      flex-direction: column;

      &__text2 {
        width: 70%;
        margin: 0 auto;
        color: #666666;
        color: var(--font-secondary);
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        span {
          font-weight: 500;
          color: #333;
          color: var(--font-primary);
        }
      }

      &__terms {
        text-align: center;
        margin-top: 16px;
        font-size: 12px;
        color: #666666;
        color: var(--font-secondary);
      }

      &__text {
        color: #666666;
        color: var(--font-secondary);
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        margin-bottom: 10px;
        margin-top: 16px;
        span {
          color: #333;
          font-size: 14px;
          font-weight: 500;
          margin-left: 8px;
          cursor: pointer;
          text-decoration: underline;
        }
      }

      &__support-premium-ad {
        display: flex;
        justify-content: center;
        margin-top: 16px;
      }
    }

    &-action {
      display: flex;
      justify-content: center;
      margin-top: 32px;

      button {
        cursor: pointer;
        background: #f1f1f1;
        background: var(--bg-secondary-hover);
        color: #666666;
        color: var(--font-secondary);
        padding: 10px 20px;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 18px;
        text-align: center;
        margin: 0 5px;
        border-radius: 6px;
        box-sizing: border-box;
        border: none;

        &:focus {
          outline: none;
        }

        &:disabled {
          background: rgba(0, 0, 0, 0.12);
          background: var(--bg-disabled-button);
          border: none;
          color: rgba(0, 0, 0, 0.26);
          color: var(--font-disabled);
          cursor: not-allowed;
        }
      }
    }

    &--full {
      background: white;
      background: var(--bg-primary);
      padding: 30px;
      box-sizing: border-box;
      border-radius: 6px;
    }
  }
}
